import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = "EUR") {
  if (value === null || value === undefined) return "-";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: currency,
  }).format(value);
}

export function formatDate(date) {
  if (!date) return "-";
  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(date));
}

export function formatDateTime(date) {
  if (!date) return "-";
  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}

export function formatPercent(value) {
  if (value === null || value === undefined) return "-";
  return `${value.toFixed(1)}%`;
}

export function getMarginColor(margin) {
  if (margin === null || margin === undefined) return "text-muted-foreground";
  if (margin > 0) return "text-emerald-600";
  if (margin < 0) return "text-red-600";
  return "text-muted-foreground";
}

export function getStatusColor(couleur) {
  return couleur || "#64748b";
}

export function maskIMEI(imei, showFull = false) {
  if (!imei) return "-";
  if (showFull) return imei;
  return `${imei.substring(0, 4)}****${imei.substring(imei.length - 4)}`;
}
